import { PostsPage } from "./pages";
import { OptionalLoggedGuard } from "hocs/guards";

const Routes = [
  {
    path: "",
    component: OptionalLoggedGuard(PostsPage),
  },
];

export default Routes;
